const colors = {
    white: "#FFF",
    whiteF2: "#F2F2F2",
    black33: "#333",
    black4F: "#4F4F4F",
    gray82: "#828282",
    grayBD: "#BDBDBD",
    redEB: "#EB5757",
    overlay: "rgba(79, 79, 79, 0.4)",
}

export default colors;